import { serializable, alias, primitive } from 'serializr';

export class MetaData {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('name', primitive()))
  name?: string;

  @serializable(alias('label', primitive()))
  label?: string;

  @serializable(alias('value', primitive()))
  value?: string | number;

  @serializable(alias('metadata_type', primitive()))
  metadataType?: string;

  @serializable(alias('createdAt', primitive()))
  createdAt?: string;

  @serializable(alias('updatedAt', primitive()))
  updatedAt?: string;

  @serializable
  key?: string;

  @serializable(alias('is_editable', primitive()))
  isEditable?: boolean;

  @serializable(alias('unique_id', primitive()))
  uniqueId?: string;
}

export class OptionsMeta {
  @serializable(primitive())
  label?: string | number;

  @serializable(primitive())
  value?: string | number;
}
